import { ref } from 'vue';

export const getAppConfig = () => {
  const key = 'root';
  const localStorageTheme = localStorage.getItem(`${key}-theme`);
  const localeStorage = localStorage.getItem(`${key}-locale`);
  const isRtl = localStorage.getItem(`${key}-isRtl`) || false;
  const locale = localeStorage || 'en';
  return {
    appConfig: {
      isManager: !key,
      key: key,
      name: import.meta.env.VITE_COMPANY_NAME || 'My App',
      logoPath: '/logo.png',
      theme: ref(localStorageTheme || 'light'),
      locale: ref(locale),
      isRtl: ref(isRtl == 'true' ? true : false),
    },
  };
};
